export const INIT = 'app/OrganizationPage/INIT';
export const INIT_SUCCESS = 'app/OrganizationPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/OrganizationPage/INIT_FAILED';

export const SAVE = 'app/OrganizationPage/SAVE';
export const SAVE_SUCCESS = 'app/OrganizationPage/SAVE_SUCCESS';
export const SAVE_FAILED = 'app/OrganizationPage/SAVE_FAILED';

export const REQUEST_ADDRESS_CHANGE = 'app/OrganizationPage/REQUEST_ADDRESS_CHANGE';
export const CLEAR_ADDRESS_CHANGE = 'app/OrganizationPage/CLEAR_ADDRESS_CHANGE';

export const key = 'organizationPage';
